import { useEffect, useState } from 'react';

import { BACKEND_ENDPOINT } from '@constants';
import { withErrorBoundary } from '@utils/errorHandler';
import tracker from '@utils/tracking';

import { AddToApple } from './AddToApple';

interface IAddToWalletProperties {
  eventId: number;
  attendeeTicketKey: string | undefined;
}

export const AddToWallet = ({
  attendeeTicketKey,
  eventId,
}: IAddToWalletProperties) => {
  const [appleActive, setAppleActive] = useState<boolean>(false);
  const [appleWalletLink, setAppleWalletLink] = useState<string>();

  const handleClick = () => {
    tracker.track({
      event: {
        event: 'Add To Apple Wallet',
        category: 'Complete',
        value: eventId,
      },
      platforms: ['ga'],
    });
  };

  useEffect(
    withErrorBoundary(() => {
      if (window.ApplePaySession) {
        setAppleActive(true);
        setAppleWalletLink(
          `${BACKEND_ENDPOINT}/api/Wallet/ApplePass?attendee_ticket_key=${attendeeTicketKey}`
        );
      }
    }),
    [attendeeTicketKey]
  );

  if (appleActive) {
    return (
      <a
        className='containerSelectedTicketButtons'
        download
        href={appleWalletLink}
        onClick={handleClick}
      >
        <div className='buttonAddToWallet'>
          <AddToApple />
        </div>
      </a>
    );
  }

  return <></>;
};

export default AddToWallet;
